import axios from "axios";

const API_URL = "https://supadaa.com/api/";

const authHeaders = (extra = {}) => ({
  Accept: "application/json",
  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  ...extra,
});

const json = () => authHeaders({ "Content-Type": "application/json" });

const getAll = async (params = {}) => {
  const res = await axios.get(`${API_URL}support-tickets`, { headers: authHeaders(), params });
  return res.data;
};

const getOne = async (id) => {
  const res = await axios.post(`${API_URL}support-tickets/show`, { id }, { headers: json() });
  return res.data;
};

const reply = async (id, message) => {
  const res = await axios.post(`${API_URL}support-tickets/reply`, { id, message }, { headers: json() });
  return res.data;
};

// data: { id, status?, priority?, handler? }
const update = async (data) => {
  const res = await axios.post(`${API_URL}support-tickets/update`, data, { headers: json() });
  return res.data;
};

const remove = async (id) => {
  const res = await axios.post(`${API_URL}support-tickets/delete`, { id }, { headers: json() });
  return res.data;
};

export default { getAll, getOne, reply, update, remove };